import { ref } from 'vue';
import type { ArrayElementType } from '@/core/types/gengeric';
import type {
  QuotaOrderQuery,
  QuotaOrderQueryVariables,
  QuotaOrdersQuery,
  QuotaOrdersQueryVariables,
} from '@/graphql/generated';
import { loadable } from '@/core/utils/store';
import {
  useAvoidOrderMutation,
  useConfirmOrderMutation,
  useQuotaOrderQuery,
  useQuotaOrdersQuery,
  useSendOrderToSupplierMutation,
} from '@/graphql/generated';

export type BookRoomCategory = ArrayElementType<QuotaOrdersQuery['quotaOrders']>['roomCategory'];

const books = ref(loadable.empty<QuotaOrdersQuery>());
const book = ref<QuotaOrderQuery>();

export const useBooksStore = () => {
  const getBook = async (payload: QuotaOrderQueryVariables, withNoReload = false) => {
    if (!withNoReload) {
      book.value = undefined;
    }

    const { request, data } = useQuotaOrderQuery(payload);

    const response = await request();

    if (data.value) {
      book.value = data.value;
    }

    return response;
  };

  const getBooks = async (payload: QuotaOrdersQueryVariables) => {
    const { request, data } = useQuotaOrdersQuery({
      ...payload,
    });

    const response = await request();

    if (data.value) {
      books.value = loadable.loaded(data.value);
    }

    return response;
  };

  const avoidBook = async (id: number) => {
    if (!book.value) {
      return;
    }

    const { request, data } = useAvoidOrderMutation({
      orderId: id,
    });

    const response = await request();

    if (data.value) {
      book.value.quotaOrder = data.value.avoidOrder.order!;
    }

    return response;
  };

  const confirmBook = async (id: number) => {
    if (!book.value) {
      return;
    }

    const { request, data } = useConfirmOrderMutation({
      orderId: id,
    });

    const response = await request();

    if (data.value) {
      book.value.quotaOrder = data.value.confirmOrder.order!;
    }

    return response;
  };

  const sendOrderToSupplier = async (id: number) => {
    if (!book.value) {
      return;
    }
    const { request, data } = useSendOrderToSupplierMutation({
      orderId: id,
    });

    const response = await request();

    if (data.value) {
      book.value.quotaOrder = data.value.sendOrderToSupplier.order!;
    }

    return response;
  };

  const resetBooks = () => {
    books.value = loadable.empty();
  };

  return {
    books,
    book,

    getBooks,
    getBook,
    resetBooks,
    avoidBook,
    confirmBook,
    sendOrderToSupplier,
  };
};
